(function(){
  function getWishlist(){
    try{ return JSON.parse(localStorage.getItem('neowear_wishlist')||'[]'); }catch(e){ return []; }
  }
  function saveWishlist(list){
    localStorage.setItem('neowear_wishlist', JSON.stringify(list));
    updateCount();
  }
  function toggleWishlist(handle){
    var list = getWishlist();
    var i = list.indexOf(handle);
    if(i > -1){ list.splice(i,1); } else { list.push(handle); }
    saveWishlist(list);
    return list.indexOf(handle) > -1;
  }
  function updateCount(){
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = list.length;
      el.classList.toggle('show', list.length > 0);
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    updateCount();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var handle = btn.getAttribute('data-wishlist-toggle');
      if(getWishlist().indexOf(handle) > -1) btn.classList.add('active');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var active = toggleWishlist(handle);
        btn.classList.toggle('active', active);
      });
    });
  });
  window.NeowearWishlist = { get: getWishlist, toggle: toggleWishlist };
})();

